export const routes = {
  HOME: '/',
  LOGIN: '/login',
  EMAIL_VERIFICATION: '/verify-email',
  STUDIER_RESTRICTED: '/studier-restricted',

  // people
  PEOPLE: '/people',
  PEOPLE__VIEW: (id = ':id') => `/people/${id}`,
  PEOPLE__INVITE: '/people/invite',

  // bible studies
  BIBLE_STUDIES: '/bible-studies',
  BIBLE_STUDIES__ADD: '/bible-studies/add',
  BIBLE_STUDIES__VIEW: (id = ':id') => `/bible-studies/${id}`,
  BIBLE_STUDIES__EDIT: (id = ':id') => `/bible-studies/${id}/edit`,

  // events
  EVENTS: '/events',
  EVENTS__ADD: '/events/add',
  EVENTS__VIEW: (id = ':id') => `/events/${id}`,
  EVENTS__EDIT: (id = ':id') => `/events/${id}/edit`,
  EVENTS__START: (id = ':id') => `/events/${id}/start`,
  EVENTS__STREAM_EVENT_ON_THIRD_PARTY: (id = ':id') => `/events/${id}/stream-event`,

  // coms
  COMMUNICATIONS: '/communications',

  // mission statement
  MISSION_STATEMENT: '/mission-statement',
  MISSION_STATEMENT__ADD: '/mission-statement/add',
  MISSION_STATEMENT__EDIT: (id = ':id') => `/mission-statement/${id}/edit`,

  // template
  TODO__LIST: '/todos',
  TODO__ADD: '/todos/add',

  // church
  CHURCH: '/churches',
  CHURCH__ADD: '/churches/add',
  CHURCH__EDIT: (id = ':id') => `/churches/${id}/edit`,

  // donations
  DONATIONS: '/donations',
  DONATION_SUCCESS: '/donation-success',
  DONATION_CANCEL: '/donation-cancel',

  // user requests
  USER_REQUESTS: '/user-requests',
};
